import { render, staticRenderFns } from "./CanvasSkeleton.vue?vue&type=template&id=73bb6fda&scoped=true&"
import script from "./CanvasSkeleton.vue?vue&type=script&lang=ts&"
export * from "./CanvasSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./CanvasSkeleton.vue?vue&type=style&index=0&id=73bb6fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bb6fda",
  null
  
)

export default component.exports